import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Holder = styled.div`
`;

function Stubble( { features, images, path } ) {

  if ( features.beard !== 'stubble' ) { return null; }

  return (
    <Holder>
      <img src={images( `${path}_beard_stubble_${features.faceshape}_${features.haircolour}.png` )} alt="stubble"/>
    </Holder>
  )
}

Stubble.propTypes = {
  features: PropTypes.object,
  images: PropTypes.func,
  path: PropTypes.string,
};

export default Stubble;
